const baseConfig = {
  appName: process.env.VUE_APP_APP_NAME || 'TEST',
  appLogo: require('@/assets/images/logo.jpg'),
  defAvatar: require('@/assets/images/avatar.png'),
  copyright: process.env.VUE_APP_COPYRIGHT || '©TEST',
}

module.exports = {
  baseConfig
}
